import React, { useState } from "react";
import { connect } from "react-redux";

import { useIntl } from "react-intl";

import EmailTemplate from "@mapmycustomers/shared/types/email/EmailTemplate";
import useDynamicCallback from "@mapmycustomers/shared/util/hook/useDynamicCallback";
import { useNonNullableContext } from "@mapmycustomers/shared/util/react";
import { Modal, TextField } from "@mapmycustomers/ui";

import EmailContext from "@app/component/email/creation/EmailContext";
import { isNewEmailTemplateCreating } from "@app/store/email";
import { createEmailTemplate } from "@app/store/email/actions";
import { RootState } from "@app/store/rootReducer";

import messages from "./messages";
import styles from "./TemplateCreateModal.module.scss";

interface TemplateCreateModalProps {
  onHide: (template?: EmailTemplate) => void;
}

const TemplateCreateModal = ({
  creating,
  onCreate,
  onHide,
}: TemplateCreateModalProps & ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps) => {
  const intl = useIntl();

  const { attachedFiles, body, entityType, resources, subject } =
    useNonNullableContext(EmailContext);
  const [name, setName] = useState<string>("");

  const handleOk = useDynamicCallback(() => {
    if (entityType) {
      onCreate({
        attachments: attachedFiles.map((attachedFile) => attachedFile.file!),
        callback: onHide,
        resources: Array.from(resources.values()),
        template: {
          body,
          entityType,
          name,
          subject,
        },
      });
    }
  });

  return (
    <Modal
      cancelText={intl.formatMessage(messages.cancel)}
      data-modal-id="saveNewTemplate"
      okButtonProps={{ disabled: !name || creating, loading: creating }}
      okText={intl.formatMessage(messages.save)}
      onCancel={() => onHide()}
      onOk={handleOk}
      open
      title={intl.formatMessage(messages.saveNewTemplate)}
    >
      <TextField
        className={styles.textField}
        label={intl.formatMessage(messages.templateName)}
        onChange={setName}
        placeholder={intl.formatMessage(messages.templateName)}
        value={name}
      />
    </Modal>
  );
};

const mapStateToProps = (state: RootState) => ({
  creating: isNewEmailTemplateCreating(state),
});

const mapDispatchToProps = {
  onCreate: createEmailTemplate.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(TemplateCreateModal);
